<template>
    <div class="has-background-grey-lighter has-text-centered"></div>
</template>

<script>
import AuthService from '@/services/auth.service';
export default {
    name: 'MLogin',
    data() {
        return {
            user: null,
            userInfo: null,
            apiCallFailed: false,
            loginFailed: false,
        };
    },
    created() {
        this.authService = new AuthService();
    },
    mounted() {
        if (!this.$store.getters.isLoggedIn && !this.$localStorage.token) {
            this.login();
        } else if (this.$localStorage.token) {
            this.performLogin(this.$localStorage.token);
        }
    },
    methods: {
        logout() {
            this.authService.logout();
        },
        login() {
            this.loginFailed = false;
            this.authService.login().then(
                (idToken) => {
                    console.log('user', idToken);
                    if (idToken) {
                        this.performLogin(idToken);
                    } else {
                        this.loginFailed = true;
                    }
                },
                () => {
                    this.loginFailed = true;
                }
            );
        },
        performLogin(idToken) {
            this.$store.dispatch('login', { idToken }).then(() => {
                if (null !== localStorage.getItem('currentUri')) {
                    if (this.$store.getters.user.validated) {
                        let currentUri = localStorage.getItem('currentUri');
                        localStorage.removeItem('currentUri');
                        this.$router.push({ path: currentUri });
                    } else {
                        this.$router.push({
                            name: 'profile',
                        });
                    }
                } else {
                    if (this.$store.getters.user.validated) {
                        this.$router.push({
                            path: '/dashboard',
                            query: {
                                filter: 'mine',
                            },
                        });
                    } else {
                        this.$router.push({
                            name: 'profile',
                        });
                    }
                }
            });
        },
    },
};
</script>

<style></style>
